module.exports = __webpack_public_path__ + "media/customizations/crosscreek/logo-7480892c65563b62fa0cc74b265ad2f9.png";